import { HttpContext, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiService, API_IGNORE_ERROR } from "@youm-front/api/data-access";
import { Observable, timeout } from "rxjs";
import { LokiPushDTO } from "../dto";
import { serializeLog } from "./redact-log";

@Injectable()
export class LokiService {
  static readonly HARD_LIMIT = 1_000;
  static readonly LIMIT = 20;

  private logs: Array<[string, string]> = [];
  private nTruncates = 0;

  static readonly TRUNCATED_MARKER = (n: number) => `***TRUNCATED*** ${n} logs`;

  constructor(private readonly apiService: ApiService) {}

  // Single entry point of every log line: redacted here, before it is
  // buffered and shipped. Strings are scrubbed as text, anything else is
  // redacted then JSON serialized.
  push(log: unknown) {
    this.logs.push([this.ts, serializeLog(log)]);

    const overflow = this.logs.length - LokiService.HARD_LIMIT;
    if (overflow > 0) {
      this.logs = this.logs.slice(-LokiService.HARD_LIMIT);
      this.nTruncates += overflow;
    }
  }

  head() {
    const logs = this.logs.slice(0, LokiService.LIMIT);
    const { nTruncates } = this;

    this.logs = this.logs.slice(LokiService.LIMIT);
    this.nTruncates = 0;

    return nTruncates > 0
      ? [
          ...logs,
          [this.ts, LokiService.TRUNCATED_MARKER(nTruncates)] as [
            string,
            string
          ]
        ]
      : logs;
  }

  unshift(logs: Array<[string, string]>) {
    this.logs = [...logs, ...this.logs];
  }

  lokiPush(lokiPushDTO: LokiPushDTO): Observable<void> {
    return this.apiService
      .post<void>(
        "loki/push",
        lokiPushDTO,
        "v1",
        new HttpHeaders(),
        new HttpContext().set(API_IGNORE_ERROR, true)
      )
      .pipe(
        // TODO https://liveedev.atlassian.net/browse/YOUM-255
        timeout(15_000)
      );
  }

  private get ts() {
    return Date.now() * 1e6 + "";
  }
}
